import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";

const ChangePasswordModal = ({ isOpen, user, onCancel, onSubmit }) => {
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setPassword("");
      setConfirmation("");
      setError("");
      setIsSaving(false);
    }
  }, [isOpen, user]);

  const handleSubmit = event => {
    event.preventDefault();

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    if (password !== confirmation) {
      setError("Password confirmation does not match.");
      return;
    }

    setError("");
    setIsSaving(true);
    onSubmit(user.id, password, confirmation)
      .then(() => onCancel())
      .catch(() => setIsSaving(false));
  };

  return (
    <Modal isOpen={isOpen} toggle={isSaving ? undefined : onCancel} className="users-modal">
      <Form onSubmit={handleSubmit}>
        <ModalHeader toggle={isSaving ? undefined : onCancel}>
          <div>
            <div className="users-modal__eyebrow">Account Security</div>
            <span className="users-modal__title">Change password</span>
            {user ? (
              <div className="users-modal__helper">
                Set a new password for {user.name || user.email}.
              </div>
            ) : null}
          </div>
        </ModalHeader>
        <ModalBody className="users-modal__body">
          {error ? <Alert color="danger">{error}</Alert> : null}
          <FormGroup>
            <Label for="user-new-password">New password</Label>
            <Input
              id="user-new-password"
              type="password"
              value={password}
              onChange={event => setPassword(event.target.value)}
              autoComplete="new-password"
              minLength={8}
              required
              disabled={isSaving}
            />
          </FormGroup>
          <FormGroup>
            <Label for="user-confirm-password">Confirm new password</Label>
            <Input
              id="user-confirm-password"
              type="password"
              value={confirmation}
              onChange={event => setConfirmation(event.target.value)}
              autoComplete="new-password"
              minLength={8}
              required
              disabled={isSaving}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit" disabled={isSaving}>
            {isSaving ? (
              <>
                <Spinner size={10} animating color="white" />&nbsp;
              </>
            ) : null}
            Update password
          </Button>
          <Button color="secondary" type="button" onClick={onCancel} disabled={isSaving}>
            Cancel
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
